import { doc, win } from "../global";
import { getContext, getJdworkState } from "./get-values-form-jdiwork";

export function getDiworkContext() {
  if (win.diworkContext && win.getUserInfo) {
    const context: any = win.diworkContext();
    const user: any = win.getUserInfo();
    return {
      uc: user.userCode,
      userid: context.userid,
      username: context.username,
      pdl: context.productLine,
      ytid: context.ytenantId, // 租户标识
      ytname: user.company, // 租户名称
    };
  }
  return null;
}
/**
 * 获取业务领域、模块等数据
 */
export async function getBizData(): Promise<BizInfo> {
  const ret: BizInfo = {};
  let context = getDiworkContext();
  if (context) {
    ret.pdl = context.pdl;
    ret.ytid = context.ytid;
    ret.ytname = context.ytname;
  } else {
    const ctx = await getContext();
    if (ctx) {
      ret.pdl = ctx.pdl;
      ret.ytid = ctx.ytid;
    }
  }
  const jDiworkState = await getJdworkState();
  let servicecode = jDiworkState?.serviceInfo?.serviceCode || jDiworkState?.activeTab;
  let servicename = jDiworkState?.serviceInfo?.serviceName;
  let tabEl = null;
  if (servicecode === 'workbench' && !servicename) {
    servicename = '首页';
  }
  if (!servicecode || !servicename) {
    tabEl = doc.querySelector('[id$=-nav].active');
    const homeBtn: HTMLElement = doc.querySelector('[fieldid=home_btn].active');
    if (homeBtn) {
      servicecode = 'workbench';
      servicename = homeBtn.innerText;
    } else if (tabEl) {
      if (!servicecode) {
        servicecode = tabEl.id.replace(/-nav$/, '');
      }
      if (!servicename) {
        servicename = (<HTMLElement>tabEl).innerText;
      }
    }
  }
  if (servicename?.length > 100) {
    servicename = servicename.slice(0, 100);
  }
  if (!servicecode) {
    hbLogger.warn('未获取到servicecode', jDiworkState);
  }
  return {
    ...ret,
    labelcode: jDiworkState?.serviceInfo?.labelCode, // 子领域编码
    labelname: jDiworkState?.serviceInfo?.labelMultiLangText?.zh_CN, // 子领域名称
    appcode: jDiworkState?.serviceInfo?.applicationCode, // 应用编码
    appname: jDiworkState?.serviceInfo?.applicationMultiLangText?.zh_CN, // 应用名称
    servicecode, // 服务编码
    servicename, // 服务名称
    rolework: jDiworkState?.workbench?.name, // 角色工作台
  };
}

/**
 * 获取当前用户信息
 */
export async function getUserInfo() {
  if (win.getUserInfo) {
    const user: any = win.getUserInfo();
    return {
      uc: user.userCode,
      userid: user.userId,
      username: user.userName,
    };
  } else {
    const { userid, username } = await getContext();
    return {
      uc: userid,
      userid,
      username,
    };
  }
}

// if(typeof win.uba === 'object' && isWorkbench()) {
//   const config = win.uba.getConfig();
//   let carr = [];
//   if(!config.getBizData) {
//     carr.push('getBizData');
//     win.uba.setConfig({ getBizData });
//   }
//   if(!config.getUser) {
//     carr.push('getUser');
//     win.uba.setConfig({ getUser: getUserInfo });
//   }
//   if(carr.length > 0) {
//     hbLogger.info('workbench setConfig:', carr);
//   }
// }
